export const BACKOFFICE_HOSTED_FEATURES = [
  'billing',
  'dispensary-users',
  'enterprise-bulk-create-users',
  'enterprise-user-permissions-report',
] as const;

export type BackofficeHostedFeature = typeof BACKOFFICE_HOSTED_FEATURES[number];

/**
 * Back Office remains the source of truth for these account-management surfaces.
 * Standalone Admin keeps its existing feature and permission checks.
 */
export function isBackofficeHostedFeatureAvailable(
  _feature: BackofficeHostedFeature,
  isBackofficeHosted: boolean
): boolean {
  return !isBackofficeHosted;
}

const HOSTED_UNAVAILABLE_ROUTE_PATTERNS = [
  /^\/dispensaries\/[^/]+\/settings\/users(?:\/|$)/,
  /^\/enterprise\/[^/]+\/settings\/users(?:\/|$)/,
  /^\/enterprise\/[^/]+\/settings\/user-permissions(?:\/|$)/,
];

export function getBackofficeHostedRedirect(
  pathname: string,
  enterpriseId: string | null | undefined,
  isBackofficeHosted: boolean
): string | null {
  if (!isBackofficeHosted || !HOSTED_UNAVAILABLE_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname))) {
    return null;
  }

  const pathEnterpriseId = /^\/enterprise\/([^/]+)/.exec(pathname)?.[1];
  const redirectEnterpriseId = pathEnterpriseId ?? enterpriseId;

  return redirectEnterpriseId ? `/enterprise/${redirectEnterpriseId}/dispensaries` : '/';
}
